import { Loader } from '@gurupay/gp-ui-library';
import { useTemplateWithAccount } from '@hooks/useTemplateWithAccount';
import { TemplatesForm } from '@pages/templates/TemplatesForm';
import { nullsToUndefined } from '@utils/utils';
import { Navigate, useParams } from 'react-router-dom';
import type { CreatePaymentTemplate } from 'types/templates';

export const TemplateEditLoader = () => {
	const { templateId } = useParams();
	const { template, isLoading, selectedAccount } = useTemplateWithAccount(templateId);

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-[500px]">
				<Loader />
			</div>
		);
	}

	if (!template) {
		return <Navigate to="templates" />;
	}

	return (
		<TemplatesForm
			selectedAccount={selectedAccount}
			template={nullsToUndefined(template) as CreatePaymentTemplate & { uuid: string }}
		/>
	);
};
